import { useIntl } from "react-intl"

import { Button, StaffBodyTextS, StaffHeading3 } from "@doktor-se/bones-ui"

import { featureFlags } from "config"

import CloseMRCL from "../CloseMRCL/CloseMRCL"

import styles from "./ConfirmCloseContent.module.scss"

interface ConfirmCloseContentProps {
  onConfirm: () => void
  isCallActive?: boolean
}

const ConfirmCloseContent = ({ onConfirm, isCallActive }: ConfirmCloseContentProps) => {
  const intl = useIntl()

  return (
    <>
      <div className={styles.textContainer}>
        <StaffHeading3>
          {featureFlags.has("mrcl")
            ? intl.formatMessage({
                id: "control.close.confirm"
              })
            : intl.formatMessage({
                id: "control.close"
              })}
        </StaffHeading3>
        {featureFlags.has("mrcl") && <CloseMRCL />}
        {isCallActive && (
          <StaffBodyTextS>
            {intl.formatMessage({
              id: "control.call.active.close"
            })}
          </StaffBodyTextS>
        )}
      </div>
      <Button variant="primary" color="primary" onPress={onConfirm} fullWidth>
        {intl.formatMessage({ id: "label.close.errand" })}
      </Button>
    </>
  )
}

export default ConfirmCloseContent
